import React, { useContext, useEffect } from "react";
import { CliffPeriod, ResultContext } from "../ResultContext";
import { LampSuggestion } from "../components/LampSuggestion";

export function VestingCliffInput({ questionId }: { questionId: number }) {
  const { result, setResult } = useContext(ResultContext);

  const foundResult = (result[questionId] as CliffPeriod) || {
    cliffOptions: false,
  };

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = { cliffOptions: false };

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);
  return (
    <div className="flex flex-column">
      <label>Cliff required?</label>
      <select
        value={foundResult.cliffOptions ? "yes" : "no"}
        onChange={(e) => {
          const copy = { ...result };

          if (e.target.value === "yes") {
            copy[questionId] = { cliffOptions: true, cliffShares: "12" };
          } else {
            copy[questionId] = { cliffOptions: false };
          }

          setResult(copy);
        }}
      >
        <option value="no">No</option>
        <option value="yes">Yes</option>
      </select>
      {foundResult.cliffOptions ? (
        <div className="flex flex-column">
          <label>Cliff period</label>
          <div className="flex items-center">
            <select
              value={foundResult.cliffShares}
              onChange={(e) => {
                const copy = { ...result };
                copy[questionId] = {
                  cliffOptions: true,
                  cliffShares: e.target.value,
                };
                setResult(copy);
              }}
            >
              {Array.from(Array(48).keys()).map((item, index) => {
                return (
                  <option value={item + 1} key={index}>
                    {item + 1}
                  </option>
                );
              })}
            </select>
            <div className=" ml-4">
              Month{parseFloat(foundResult.cliffShares) !== 1 ? "s" : null}
            </div>
          </div>
        </div>
      ) : null}
      <LampSuggestion
        text={
          "The average cliff has a duration of 12 months. If you have opted for a backdated start date, be aware that your cliff will be shortened or even not relevant anymore."
        }
      />
    </div>
  );
}
